import { ContentDataBlockDelimiter } from '@amf/shared/components/content/Content';

interface DelimiterProps {
  block: ContentDataBlockDelimiter;
}

export default function Delimiter({}: DelimiterProps) {
  return <hr />;
}
